export const CONFIRMATION_TYPES = Object.freeze(["Debitorenbestätigung", "Bankbestätigung", "Rechtsanwaltsbestätigung", "Andere Bestätigung"]);
export const CONFIRMATION_STATUSES = Object.freeze(["noch zu organisieren", "eingefordert / noch nicht erhalten", "erhalten"]);

export function confirmationFilters(search = "") {
  const params = new URLSearchParams(search);
  return { mandatId: params.get("mandatId") || "", status: params.get("status") || "", type: params.get("type") || "", id: params.get("bestaetigungId") || "" };
}

export function filterConfirmations(items, filters, references) {
  return (items || []).filter(item => (!filters.mandatId || item.mandatId === filters.mandatId) && (!filters.status || references.status[item.bestaetigungsstatusId] === filters.status) && (!filters.type || references.type[item.bestaetigungsartId] === filters.type));
}

/**
 * Resolves the persisted foreign keys used by confirmations and creates the
 * single data set consumed by every confirmation overview.
 *
 * Inactive status references deliberately remain invalid: they may still be
 * present on historic records, but must not be presented as a current
 * business status. Rejected records are returned separately so callers can
 * make the data-quality problem visible instead of silently changing totals.
 */
export function groupConfirmations(items = [], projects = [], statusReferences = []) {
  const projectIds = new Set(projects.map((project) => project.id));
  const statusById = new Map(
    statusReferences
      .filter((reference) => reference.aktiv !== false && CONFIRMATION_STATUSES.includes(reference.name))
      .map((reference) => [reference.id, reference.name]),
  );
  const groups = Object.fromEntries(CONFIRMATION_STATUSES.map((status) => [status, []]));
  const valid = [];
  const orphaned = [];
  const invalid = [];

  for (const confirmation of items) {
    if (!confirmation?.mandatId || !projectIds.has(confirmation.mandatId)) {
      orphaned.push(confirmation);
      continue;
    }
    const status = statusById.get(confirmation.bestaetigungsstatusId);
    if (!status) {
      invalid.push(confirmation);
      continue;
    }
    const normalized = { ...confirmation, status };
    valid.push(normalized);
    groups[status].push(normalized);
  }

  return {
    items: valid,
    groups,
    total: valid.length,
    orphaned,
    invalid,
    rejectedCount: orphaned.length + invalid.length,
  };
}
